import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';
import { IApplicantDTO } from 'src/modules/shared/interfaces/IApplicantDTO';
import { IContact } from 'src/modules/shared/interfaces/IContact';
import { IAuthenticationCredentials } from 'src/modules/shared/interfaces/IAuthenticationCredentials';
import {INewApplicantAddRequest} from "../../shared/interfaces/INewApplicantAddRequest";
import {IGetOperationResponse} from "../../shared/interfaces/IGetOperationResponse";

@Injectable({
  providedIn: 'root'
})
export class ApplicantManagementService {
  public appBaseUrl: string;
  public appUrl: string;
  public authUrl: string;

  constructor(private http: HttpClient, private appConfig: AppConfigService) {
    this.appBaseUrl = this.appConfig.getAppConfig().AppUrl;
    this.appUrl = this.appConfig.getAppConfig().AppUrl + '/api/UserDataManager';
    this.authUrl = `${this.appBaseUrl}/api/auth`;
  }

  addNewApplicant(addNewApplicantRequest: INewApplicantAddRequest) {
    return this.http.post<IGetOperationResponse<IContact>>(`${this.authUrl}/AddNewApplicant`, addNewApplicantRequest);
  }

  GetCompanyAvailableApplicants(applicantDTO: IApplicantDTO): Observable<IApplicantDTO> {
    return this.http.post<IApplicantDTO>(this.appUrl + '/GetCompanyAvailableApplicantsWithPrivilege', applicantDTO);
  }

  GetLoggedInApplicant(): Observable<IContact> {
    return this.http.get<IContact>(this.appUrl + '/GetLoggedInApplicant');
  }

  GetUserInformation(): Observable<IContact> {
    return this.http.get<IContact>(this.appUrl + '/GetUserInformation');
  }
  GetApplicantDetails(applicantId: string): Observable<IContact> {
    return this.http.get<IContact>(this.appUrl + '/GetApplicantDetails?applicantId=' + applicantId);
  }

  GetApplicantServices(applicantId, module): Observable<any> {
    return this.http.get<any>(this.appUrl + '/GetIndividualGrantedServices?contactId=' + applicantId + '&module=' + module);
  }

  GetModuleServices(module: string): Observable<any> {
    const headers = new HttpHeaders().set("Module", module);
    return this.http.get<any>(this.appUrl + `/GetModuleServices?module=${module}`,{ headers });
  }

  UpdateContactsList(request: any): Observable<any> {
    return this.http.post<any>(this.appUrl + '/UpdateContactsList', request);
  }

  UpdateKeyPerson(request: any): Observable<any> {
    return this.http.post<any>(this.appUrl + '/UpdateKeyPerson', request);
  }

  GrantService(request: any): Observable<any> {
    return this.http.post<any>(this.appUrl + '/GrantService', request);
  }

  RevokeService(request: any): Observable<any> {
    return this.http.post<any>(this.appUrl + '/RevokeService', request);
  }

  CheckIfTheSelectedApplicantIsTheLoggedInUser(cpr:string): Observable<any> {
    return this.http.get<object>(this.appUrl + '/CheckIfTheSelectedApplicantIsTheLoggedInUser?cpr='+cpr)
  }
  
  getOptionSets(OptionSetName:string,EntityName:string):Observable<any>{
    let url=this.appConfig.getAppConfig().AppUrl+"/api/App/GetFilteredOptionSetValues";
    return this.http.get<object>(url+"?OptionSetName="+OptionSetName+"&EntityName="+EntityName+"&lang="+"en");
  }

  RequestAuthentication(): Observable<any> {
    return this.http.get<any>(this.appUrl + '/RequestAuthentication');
  }
  
  RequestingAuthenticationResult(authenticationCredentials: IAuthenticationCredentials): Observable<any> {
    return this.http.post<any>(this.appUrl + '/RequestingAuthenticationResult', authenticationCredentials);
  }
}
